import axios from "axios";
import API from "../../../api";

export async function get(assuranceType, mainToken, simulationId) {
  const params = {
    simulationId
  };
  return new Promise(resolve => {
    const url = API.tunnel.common.recapitulatif[assuranceType];
    const request = axios.get(url, {
      params,
      headers: {
        Authorization: `bearer ${mainToken}`
      }
    });
    return request
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        resolve({ error: true, res: err });
      });
  });
}
